import React from 'react';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import PracticeAreas from '../components/PracticeAreas';
import Products from '../components/Products';
import About from '../components/About';
import Clients from '../components/Clients';
import Resources from '../components/Resources';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Careers from '../components/Careers';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <PracticeAreas />
        <Products />
        <About />
        <Clients />
        <Resources />
        <Testimonials />
        <Contact />
        <Careers />
      </main>
      <Footer />
    </div>
  );
};

export default Home;